import { render } from "./exam-item.vue?vue&type=template&id=489df64e&scoped=true"
import script from "./exam-item.vue?vue&type=script&lang=js"
export * from "./exam-item.vue?vue&type=script&lang=js"

import "./exam-item.vue?vue&type=style&index=0&id=489df64e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489df64e"]])

export default __exports__